var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCart20(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    width: 20,
    height: 20,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF9F19"
    },
    d: "M289.375,22.37c-12.869,0-24.498,5.015-33.376,13.021c-8.878-8.006-20.507-13.021-33.376-13.021 c-27.606,0-50.064,22.457-50.064,50.064s22.458,50.064,50.064,50.064c12.869,0,24.498-5.015,33.376-13.021 c8.878,8.006,20.507,13.021,33.376,13.021c27.606,0,50.064-22.457,50.064-50.064S316.982,22.37,289.375,22.37z M222.623,89.121 c-9.202,0-16.688-7.486-16.688-16.688s7.486-16.688,16.688-16.688c9.202,0,16.688,7.486,16.688,16.688 S231.826,89.121,222.623,89.121z M289.375,89.121c-9.202,0-16.688-7.486-16.688-16.688s7.486-16.688,16.688-16.688 c9.202,0,16.688,7.486,16.688,16.688S298.578,89.121,289.375,89.121z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F28618"
    },
    d: "M289.375,122.497c27.606,0,50.064-22.457,50.064-50.064S316.981,22.37,289.375,22.37 c-12.869,0-24.498,5.015-33.376,13.021v74.085C264.877,117.482,276.506,122.497,289.375,122.497z M289.375,55.746 c9.202,0,16.688,7.486,16.688,16.688s-7.486,16.688-16.688,16.688c-9.202,0-16.688-7.486-16.688-16.688 S280.173,55.746,289.375,55.746z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE14D"
    },
    d: "M428.441,189.249H83.557c-9.213,0-16.688-7.475-16.688-16.688v-33.376 c0-27.606,22.458-50.064,50.064-50.064h278.132c27.606,0,50.064,22.457,50.064,50.064v33.376 C445.129,181.774,437.655,189.249,428.441,189.249z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFCC33"
    },
    d: "M395.065,89.121H255.999v100.128h172.442c9.213,0,16.688-7.475,16.688-16.688v-33.376 C445.129,111.578,422.672,89.121,395.065,89.121z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E6563A"
    },
    d: "M444.687,489.631H67.311c-36.001,0-65.629-28.563-66.864-64.543 c-3.301-96.203,10.986-174.714,66.469-269.196c0.007-0.011,378.266-0.019,378.266-0.019c55.491,94.477,69.67,172.991,66.369,269.213 C510.317,461.066,480.69,489.631,444.687,489.631z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D9472B"
    },
    d: "M255.999,489.631h188.688c36.001,0,65.629-28.564,66.864-64.544 c3.301-96.221-10.879-174.737-66.369-269.213c0,0-94.599,0.002-189.183,0.006L255.999,489.631L255.999,489.631z"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCart20);
export default __webpack_public_path__ + "static/media/cart-20.966ad68ee9074836e6c21421dc866989.svg";
export { ForwardRef as ReactComponent };